import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import RoleToggle from "../../components/RoleToggle";
import ReceivingTicketsTab from "./_components/ReceivingTicketsTab";
import CreatedTicketsTab from "./_components/CreatedTicketsTab";
import ChatSupportListTab from "./_components/ChatSupportListTab";

const HelpandSupport: React.FC = () => {
  const mainTabs = ["Receiving", "Created"];
  const modules = ["Tickets Support", "Chat Support"];

  const [searchParams] = useSearchParams();

  const [activeModule, setActiveModule] = useState<string>(
    () => {
      if (searchParams.get('chatId') || searchParams.get('type') === 'DIRECT') return "Chat Support";
      if (searchParams.get('type') === 'TICKET') return "Tickets Support";
      return localStorage.getItem("HelpSupportActiveModule") || "Tickets Support"
    }
  );
  const [activeTab, setActiveTab] = useState<string>(
    () => localStorage.getItem("HelpSupportActiveTab") || "Receiving"
  );

  useEffect(() => {
    localStorage.setItem("HelpSupportActiveModule", activeModule);
  }, [activeModule]);

  useEffect(() => {
    localStorage.setItem("HelpSupportActiveTab", activeTab);
  }, [activeTab]);

  useEffect(() => {
    if (searchParams.get('chatId') || searchParams.get('type') === 'DIRECT') {
      setActiveModule("Chat Support");
    } else if (searchParams.get('type') === 'TICKET') {
      setActiveModule("Tickets Support");
    }
  }, [searchParams]);

  return (
    <>
      <div className="p-4 pt-0 space-y-4">
        <div className="flex flex-col gap-3">
          {/* Main Module Tabs */}
          <div className="flex items-center gap-4">
            <RoleToggle
              options={modules}
              active={activeModule}
              onChange={setActiveModule}
              containerClassName="inline-flex rounded-full bg-white border border-[#D8D8D8] py-0.5 px-1 space-x-2"
              activeClassName="bg-[#FBD037] text-black shadow-sm"
              inactiveClassName="bg-transparent text-[#212121]/70"
            />
          </div>

          {/* Sub Tabs for Tickets Support */}
          {activeModule === "Tickets Support" && (
            <div className="flex items-center gap-4">
              <RoleToggle
                options={mainTabs}
                active={activeTab}
                onChange={setActiveTab}
              />
            </div>
          )}
        </div>

        {/* Content */}
        {activeModule === "Tickets Support" && activeTab === "Receiving" && <ReceivingTicketsTab />}
        {activeModule === "Tickets Support" && activeTab === "Created" && <CreatedTicketsTab />}
        {activeModule === "Chat Support" && <ChatSupportListTab />}
      </div>
    </>
  );
};

export default HelpandSupport;
